import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, Input, HostBinding, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { isPlatformServer, CommonModule } from '@angular/common';
function FeedbackComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
  }
}
const _c0 = ["*"];
function FeedbackContainerComponent_met_feedback_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "met-feedback", 1);
    i0.ɵɵtext(1, "\xA0");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("pulse", false)("invalid", true);
  }
}
let FeedbackComponent = /*#__PURE__*/(() => {
  class FeedbackComponent {
    constructor(platformId) {
      this.platformId = platformId;
      this.block = true;
      this.invalid = false;
      this.pulse = true;
    }
    ngOnInit() {
      if (isPlatformServer(this.platformId)) {
        return;
      }
      setTimeout(() => {
        this.pulse = false;
      }, 3000);
    }
    static {
      this.ɵfac = function FeedbackComponent_Factory(t) {
        return new (t || FeedbackComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FeedbackComponent,
        selectors: [["met-feedback"]],
        hostVars: 4,
        hostBindings: function FeedbackComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("d-block", ctx.block)("invalid-feedback", ctx.invalid);
          }
        },
        inputs: {
          block: "block",
          invalid: "invalid",
          pulse: "pulse"
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 1,
        consts: [["class", "pulse-border", 4, "ngIf"], [1, "pulse-border"]],
        template: function FeedbackComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, FeedbackComponent_div_0_Template, 1, 0, "div", 0);
            i0.ɵɵprojection(1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pulse);
          }
        },
        dependencies: [i1.NgIf],
        styles: ["[_nghost-%COMP%]{position:relative}.pulse-border[_ngcontent-%COMP%]{display:block;border-radius:8px;position:absolute;animation:_ngcontent-%COMP%_animation-pulse-edge 1s ease-out;animation-iteration-count:infinite;border-width:2px;border-style:solid;border-color:RGB(241,65,108);inset:0}@keyframes _ngcontent-%COMP%_animation-pulse-edge{0%{-webkit-transform:scale(1,1);opacity:0}40%{opacity:1}80%{opacity:1}to{-webkit-transform:scale(1.1,1.1);opacity:0}}"]
      });
    }
  }
  return FeedbackComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FeedbackContainerComponent = /*#__PURE__*/(() => {
  class FeedbackContainerComponent {
    static {
      this.ɵfac = function FeedbackContainerComponent_Factory(t) {
        return new (t || FeedbackContainerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FeedbackContainerComponent,
        selectors: [["met-feedback-container"]],
        contentQueries: function FeedbackContainerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, FeedbackComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.feedbacks = _t);
          }
        },
        ngContentSelectors: _c0,
        decls: 2,
        vars: 1,
        consts: [[3, "pulse", "invalid", 4, "ngIf"], [3, "pulse", "invalid"]],
        template: function FeedbackContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, FeedbackContainerComponent_met_feedback_1_Template, 2, 2, "met-feedback", 0);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ((tmp_0_0 = ctx.feedbacks == null ? null : ctx.feedbacks.length) !== null && tmp_0_0 !== undefined ? tmp_0_0 : 0) === 0);
          }
        },
        dependencies: [i1.NgIf, FeedbackComponent]
      });
    }
  }
  return FeedbackContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormModule = /*#__PURE__*/(() => {
  class FormModule {
    static {
      this.ɵfac = function FormModule_Factory(t) {
        return new (t || FormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return FormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FeedbackComponent, FeedbackContainerComponent, FormModule };
